<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i>Excel Filter</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="ExcelFilterForm" (ngSubmit)="Verification(ExcelFilterForm)" #ExcelFilterForm="ngForm"
        novalidate>
        <div class="row m-1">
            <div class="col-md-6"></div>
            <div class="col-md-4" style="align-content: center;">
                <label class="Label">
                    Filter Date
                    <input type="checkbox" name="IncludeDate" [(ngModel)]="Filter.IncludeDate" #IncludeDate="ngModel"
                        ngbCheckbox />
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-6">
                <label for="BranchID" class="text-label-dark">Branch</label>
                <ng-select name="BranchID" placeholder="Select branch" [(ngModel)]="Filter.BranchID" [items]="Branchs"
                    bindLabel="BranchName" bindValue="BranchMasterID">
                </ng-select>
            </div>
            <!-- <div class="col-md-6">
                <label for="Category" class="text-label-dark mb-2">Employee Type</label>
                <br />
                @for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory;
                let i =
                $index) {
                <label class="form-check-label link-dark px-1" ngbButtonLabel>
                    <input class="form-check-input" type="radio" [value]=EmployeeCategory.Value id="Category" #Category name='Category'
                        [(ngModel)]="Filter.EmpType" [ngModelOptions]="{standalone: true}">
                    {{EmployeeCategory.EmployeeCategory}}
                </label>
                }
                <label class="form-check-label link-dark px-1" ngbButtonLabel>
                    <input class="form-check-input" type="radio" [value]='' name='Category' id="Category" #Category [(ngModel)]="Filter.EmpType"
                        [ngModelOptions]="{standalone: true}">
                    Both
                </label>
            </div> -->
            <div class="col-md-3">
                <label for="FromDateObj" class="form-font-label"><span class="text-danger">*</span>From
                    Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                        [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required readonly
                        [disabled]="!Filter.IncludeDate" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                        type="button" [disabled]="!Filter.IncludeDate"></button>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="ToDateObj" class="form-font-label"><span class="text-danger">*</span>To
                    Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj" [(ngModel)]="Filter.ToDateObj"
                        ngbDatepicker #ToDateObj="ngbDatepicker" required readonly [disabled]="!Filter.IncludeDate" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()" type="button"
                        [disabled]="!Filter.IncludeDate"></button>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>

            </div>
        </div>
        
        <div class="row m-1">
            <label class="reset my-1" style="justify-content: right;">Note : Click Filter Button to Excel</label>
        </div>

        <div class="row m-1 ">
            <button class="btn btn-primary" [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Filter':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>